module.exports = __webpack_public_path__ + "media/images/flf-texture_printed-a698c9d8e40ec9e9c9c69deca974ff36.jpg";